export default {
  news: {
    default: 'Actualités',
    list: {
      page_title: 'Liste des actualités',
      date: 'Date',
      name: 'Titre',
      weight: 'Poids',
      _notify_users: 'Notifier tous les utilisateurs'
    },
    edit: {
      page_title: 'Modification de l\'actualité :'
    },
    show: {
      page_title: 'Fiche de l\'actualité :',
      date: 'Date'
    },
    create: {
      page_title: "Création d'une actualité"
    },
    empty: 'Aucune actualité',
    notif: 'Une nouvelle actualité vient d\'être postée, . Ne tardez pas à découvrir les nouvelles fonctionnalités de la plateforme. '
  }
}
